import './footer.scss';

import React, {useState} from 'react';
import {Col, Modal, ModalBody, ModalFooter, ModalHeader, Row} from "reactstrap";
import {Button} from "edozvola-frontend-lib/dist/ui/components/button";

const Footer = () => {
  const [showConfirmationModal, setShowConfirmationModal] = useState<boolean>(false);
  const [selectedDestination, setSelectedDestination] = useState<string>(null);

  const openConfirmationModal = (destination: string) => {
    setSelectedDestination(destination);
    setShowConfirmationModal(true);
  }

  const navigateToDestination = () => {
    window.open(selectedDestination, '_blank', 'rel=noopener=true,noreferrer=true,popup=false');
    setShowConfirmationModal(false);
    setSelectedDestination(null);
  }

  return (
    <>
      <div id="footer" className="footer">
        <Row>
          <Col md={3}>
            <div className="d-flex justify-content-md-start">
              <span><span style={{color: '#ca1720'}}>e</span>Dozvola</span>
            </div>
          </Col>
          <Col md={3}>
            <div className="d-flex justify-content-md-start">
              <a onClick={() => openConfirmationModal("https://mpgi.gov.hr/")} target="_blank"
                 title="Portal Ministarstva prostornog uređenja, graditeljstva i državne imovine">
                <img src="content/svg/mpgi_logo.svg" height={40}/>
              </a>
            </div>
          </Col>
          <Col md={3}>
            <div className="d-flex justify-content-md-center">
              <a onClick={() => openConfirmationModal("https://portal-ispu.gov.hr/hr")} target="_blank"
                 title="Portal Informacijskog sustava prostornog uređenja">
                <img src="content/svg/ispu_logo.svg" height={40}/>
              </a>
            </div>
          </Col>
          <Col md={3}>
            <div className="d-flex justify-content-md-end">
              <a onClick={() => openConfirmationModal("https://europa.eu/youreurope/")} target="_blank" style={{marginTop: "5px"}}
                 title="Službeni portal Europske unije">
                <img src="content/svg/youreurope_logo.svg" width={120} height={50}/>
              </a>
            </div>
          </Col>
        </Row>
      </div>
      <Modal centered isOpen={showConfirmationModal}>
        <ModalHeader>Otvaranje u novom prozoru</ModalHeader>
        <ModalBody>
          Stranica će se otvoriti u novom prozoru. Želite li nastaviti?
        </ModalBody>
        <ModalFooter>
          <Button size={'lg'} label={'Odustani'} outline onClick={() => setShowConfirmationModal(false)}/>
          <Button size={'lg'} label={'Nastavi'} color={'info'} onClick={() => navigateToDestination()}/>
        </ModalFooter>
      </Modal>
    </>
  );
}

export default Footer;
